import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import { FILTERKEYS } from './constants';
import TextStyle from './TextStyle/TextStyle';

const TextStylesList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup);

  return (
    <Fragment>
      {dataKeys.map(group => (
        <section key={`${group}-text-group`}>
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul className="showcase-list">
            {
              dataGroup[group].map((textStyle, i) => (
                <li key={`textStyle-${textStyle.type}-showcase-${i}`}>
                  <TextStyle {...textStyle} />
                </li>
              ))
            }
          </ul>
        </section>
      ))}
    </Fragment>
  );
};

TextStylesList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

TextStylesList.displayName = 'TextStylesList';

export default TextStylesList;



// WEBPACK FOOTER //
// ./src/containers/foundations/TextStyles/TextStylesList.js